const mediaQuery = window.matchMedia("(max-width: 767.98px)");
function footerLinksCollapseable(e) {
  if (e.matches) {
    console.log("Media Query Matched!");
    $(".footer-item__title").click(function () {
      $(this).next().slideToggle("fast").parent().toggleClass("active");
    });
  }
}
mediaQuery.addListener(footerLinksCollapseable);
footerLinksCollapseable(mediaQuery);


$(document).ready(function(){
  $(document).on('click','.cart-promo #redemDevPromo',function(event){
    event.preventDefault();
    var theUrl = '/checkout?discount=';
    var theDiscount = $('#devPromo').val();
    var toRedirect = theUrl+theDiscount;
    window.location.href = toRedirect;
  });
  $('#site-cart-sidebar .discount-code-main .discount-title').on('click', function(event){
    $('.cart-promo').removeAttr('data-hide-discount');
    $('#site-cart-sidebar .cart__discounts.cart__details--row').hide();
  });
});

$(".go-to-top-btn a").on('click',function(event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($(this).attr('data-id')).offset().top - 150
    }, 50);
});


$(document).ready(function(){

  // Product Page After ATC scrolling text
    if( jQuery('.marquee-info').length ){
      jQuery('.marquee-info').marquee({
          duration: 12000,
          gap: 10,
          delayBeforeStart: 0,
          direction: 'left',
          duplicateCount: 3,
          duplicated: true,
          startVisible: true    
      });
    };

  // tippy('#infotext', {
		// trigger: 'click',
		// theme: 'light',
  //       content: 'Vi fejrer World Sleep Day! 🎉 I 24 timer får du 24% rabat på ALT – husk at tilføje koden 24TIMER ved betaling. Forkæl din søvn, før tilbuddet forsvinder! 😴💜',
  //     });

  
  function slider_new_product(color) {
    jQuery('.gallery-design-three .product-gallery-item,.product-gallery__thumbnails .thumbnail').hide();
    jQuery('.gallery-design-three .product-gallery-item[thumbnail-color="'+color+'"],.product-gallery__thumbnails .thumbnail[thumbnail-color="'+color+'"]').show();
  }
  jQuery('.gallery-design-three .product-text .product-variant__container--radio .custom-color-op.product-variant__item--radio').on('click',function() {
      var active_color = jQuery('.gallery-design-three .product-text .product-variant__container--radio .custom-color-op input:checked').val();
      slider_new_product(active_color);
  })
  setTimeout(function(){ 
    if(jQuery('.gallery-design-three .product-text .product-variant__container--radio .custom-color-op').length){
      var get_active_color = $('.gallery-design-three .product-text .product-variant__container--radio .custom-color-op input:checked').attr('value');
      slider_new_product(get_active_color); 
      // slider_new_product('Darkgrey'); 
      // slider_new_product('Grå'); 
      // slider_new_product('Mocha');
      // console.log(`{{ product.selected_or_first_available_variant}}`);
    }
  },800);
  
  // menu hover image change
  jQuery('.custom-color-html .color-name-more').on('mouseenter',function(){
    var get_img_menu = $(this).attr('data-color-img');
    $(this).closest('.product-item').find('.product-item__image img').attr('src',get_img_menu).attr('srcset',get_img_menu);
  })

  jQuery('body').on('click','.product-text .product-variant__container--radio .product-variant__item--radio',function() {
      var active_color_text = $(this).find('input:checked').val();
      $(this).closest('.product-variant').find('.product-variant__item-text-label').text(active_color_text);
  })
});   

$(document).ready(function() {
     var second = 1000,
    minute = second * 60,
    hour = minute * 60,
    _day = hour * 24;

var countDown_aa = new Date('march 14, 2025 23:59:59').getTime(),
    x = setInterval(function () {
        if (jQuery('.flashtimer.ann-timer').length == 1) {
            var now = new Date().getTime(),
                distance = countDown_aa - now;

            if (distance < 1) {
                var hr = 23;
                var min = 59;
                var sec = 60;
                var distance = 1;
                x = setInterval(function () {
                    var curr = new Date();
                    jQuery('.flashtimer .js-timer-hours').text(hr - curr.getHours() + 't');
                    jQuery('.flashtimer .js-timer-minutes').text(min - curr.getMinutes() + 'm');
                    jQuery('.flashtimer .js-timer-seconds').text(sec - curr.getSeconds() + 's');
                    flashCountdown_aa(10);
                }, second);
            } else {
                if(Math.floor(distance / (_day)) != 0){
                  jQuery('.flashtimer .timer-block.days-timer').show();
                  jQuery('.flashtimer .js-timer-days').text(Math.floor(distance / (_day)) + 'd');
                }else{
                  jQuery('.flashtimer .timer-block.days-timer').hide();
                }
                jQuery('.flashtimer .js-timer-hours').text(Math.floor((distance % (_day)) / hour) + 't');
                jQuery('.flashtimer .js-timer-minutes').text(Math.floor((distance % (hour)) / minute) + 'm');
                jQuery('.flashtimer .js-timer-seconds').text(Math.floor((distance % (minute)) / second) + 's');
                flashCountdown_aa(10);
            }
        }
    }, second);

function flashCountdown_aa(timeleft) {
    var downloadTimer = setInterval(function () {
        if (timeleft <= 0) {
            clearInterval(downloadTimer);
        } else {
            if (jQuery('.flashtimer .js-timer-ms').length == 1) {
                jQuery('.flashtimer .js-timer-ms').text(timeleft);
            }
        }
        timeleft -= 1;
    }, 100);
}
});